import { Routes } from '@angular/router';
import { AgentComponent } from './routes/core/agent/agent.component';
import { LoginComponent } from './routes/auth/login/login.component';
import { ForgotComponent } from './routes/auth/forgot/forgot.component';
import { ResetComponent } from './routes/auth/reset/reset.component';
import { RegisterComponent } from './routes/auth/register/register.component';
import { ConnectionsComponent } from './routes/core/connections/connections.component';
import { ProfileComponent } from './routes/core/profile/profile.component';

import { adminGuard, authGuard, noAuthGuard, onboardGuard, profileGuard, subscriptionGuard } from './gaurds/guards';
import { GetStartedComponent } from './routes/onboard/get-started/get-started.component';

import { AdminFlightDataComponent } from './routes/admin/admin-flight-data/admin-flight-data.component';
import { AdminHqDashboardComponent } from './routes/admin/admin-hq-dashboard/admin-hq-dashboard.component';
import { AdminReviewMembershipsComponent } from './routes/admin/admin-review-memberships/admin-review-memberships.component';
import { InitializeComponent } from './routes/core/initialize/initialize.component';
import { WatchersComponent } from './routes/core/watchers/watchers.component';
import { ViewWatcherComponent } from './routes/core/watchers/components/view-watcher/view-watcher.component';
import { ViewConnectionComponent } from './routes/core/connections/components/view-connection/view-connection.component';
import { VerifyPhoneComponent } from './routes/onboard/verify-phone/verify-phone.component';
import { MembershipComponent } from './routes/core/membership/membership.component';
import { VerifyMembershipComponent } from './routes/core/verify-membership/verify-membership.component';
import { AccountComponent } from './routes/core/account/account.component';
import { SubscribeComponent } from './routes/core/subscribe/subscribe.component';
import { AccountTypeComponent } from './routes/onboard/account-type/account-type.component';
import { TrustedContactsComponent } from './routes/core/trusted-contacts/trusted-contacts.component';
import { InviteCodeComponent } from './routes/onboard/invited-party/invite-code/invite-code.component';
import { VerifyIdentityComponent } from './routes/onboard/invited-party/verify-identity/verify-identity.component';
import { InvitedAircraftComponent } from './routes/onboard/invited-party/aircraft/invited-aircraft.component';

export const routes: Routes = [
  // AUTH
  { path: 'login', component: LoginComponent, canActivate: [noAuthGuard] },
  { path: 'forgot', component: ForgotComponent },
  { path: 'reset', component: ResetComponent },
  { path: 'register', component: RegisterComponent, canActivate: [noAuthGuard] },
  { path: 'initialize', component: InitializeComponent, canActivate: [authGuard] },

  // CORE
  { path: '', redirectTo: 'agent', pathMatch: 'full' },
  { path: 'agent', component: AgentComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'connections', component: ConnectionsComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'connection/:id', component: ViewConnectionComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'watchers', component: WatchersComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'watcher/:id', component: ViewWatcherComponent, canActivate: [authGuard, profileGuard, subscriptionGuard], data: { isPersistent: false } },
  { path: 'persistent-watcher/:id', component: ViewWatcherComponent, canActivate: [authGuard, profileGuard, subscriptionGuard], data: { isPersistent: true } },

  // USER
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'trusted-contacts', component: TrustedContactsComponent, canActivate: [authGuard, profileGuard, subscriptionGuard] },
  { path: 'create-invite', redirectTo: 'trusted-contacts', pathMatch: 'full' },
  { path: 'membership', component: MembershipComponent, canActivate: [authGuard] },
  { path: 'account', component: AccountComponent, canActivate: [authGuard, profileGuard] },
  { path: 'subscribe', component: SubscribeComponent, canActivate: [authGuard, profileGuard] },
  { path: 'membership/:id', component: MembershipComponent, canActivate: [authGuard] },
  { path: 'membership/verify/:id', component: VerifyMembershipComponent, canActivate: [authGuard] },

  // ONBOARD
  { path: 'onboard/verify-phone', component: VerifyPhoneComponent, canActivate: [onboardGuard] },
  { path: 'onboard/account-type', component: AccountTypeComponent, canActivate: [onboardGuard] },
  { path: 'onboard/invited-party/invite-code', component: InviteCodeComponent, canActivate: [onboardGuard] },
  { path: 'onboard/invited-party/verify', component: VerifyIdentityComponent, canActivate: [onboardGuard] },
  { path: 'onboard/invited-party/aircraft', component: InvitedAircraftComponent, canActivate: [onboardGuard] },
  { path: 'onboard/membership', component: MembershipComponent, canActivate: [onboardGuard] },
  { path: 'onboard/membership/verify/:id', component: VerifyMembershipComponent, canActivate: [onboardGuard] },
  { path: 'onboard/get-started', component: GetStartedComponent, canActivate: [onboardGuard] },

  // ADMIN
  { path: 'admin/hq', component: AdminHqDashboardComponent, canActivate: [adminGuard] },
  { path: 'admin/flights', component: AdminFlightDataComponent, canActivate: [adminGuard] },
  { path: 'admin/review-memberships', component: AdminReviewMembershipsComponent, canActivate: [adminGuard] },

  { path: '**', redirectTo: 'agent', pathMatch: 'full' }
];
